import React from 'react';
import {Link} from 'react-router-dom'
import SEO from '../Component/SEO';

function Code() {
  return (  
  <div className="container-fluid code-top">
  
<SEO
        title="Careers & Jobs at NLF Solutions | Opportunities Across India"
        description="Explore career opportunities at NLF Solutions and join our team working on innovative architectural, building, ceiling, facade, roofing and interior solutions."
        canonical="https://nlfs.in/gallery"
        // keywords="Architectural Project Gallery, NLF projects, Architectural projects, Completed projects, Facade projects, Interior projects, Ceiling projects, Project portfolio, architectural projects in India, architectural project gallery, commercial architectural projects, completed architectural projects"
      />
      <h1 className="seo-h1">Our Architectural Projects</h1>

<section className="mainContent"
 data-aos="fade-up" data-aos-delay={100}
 >
  <div className="container-fluid color-bgWhite pb-5">
    <div className="container big-container ">
      <div className="row">
        <div
          className="col-md-12 text-center"
          data-aos="fade-up"
          data-aos-delay={100}
        >
          <div className="top-content-wrapper">
            <h1>Design Your Future With Us</h1>
            <p>
              {/* We have created a work environment where Systians feel encouraged,
              heard, and supported. We cherish inclusivity &amp; diversity at
              our workplace where everyone has an equal opportunity to grow. */}
              Join us to be part of an exciting journey where your ideas and contributions truly matter!
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div
          className="col-md-6 text-center"
          data-aos="fade-right"
          data-aos-delay={100}
        >
          <div className="div_box">
            <div className="image_box_car">
              <img
                className="img-fluid"
                src="career-img/block1.jpg"
                alt="Gsuntec Career"
              />
            </div>
            <div className="content_box_car">
              <h2>Innovative Culture</h2>
              <p>
At NLF Furnitures, innovation isn’t just a buzzword—it’s the foundation of everything we do. From turnkey interior projects that redefine modern living to pioneering green building solutions and crafting bespoke furniture, our work sits at the intersection of creativity, functionality, and sustainability. Joining our team means contributing to projects that push boundaries, embrace new materials and technologies, and deliver spaces that inspire. Whether you're an architect, designer, engineer, or artisan, you'll be encouraged to think beyond convention and leave your mark on industry-leading work.

              </p>
            </div>
          </div>
        </div>
        <div
          className="col-md-6 text-center"
          data-aos="fade-up"
          data-aos-delay={100}
        >
          <div className="div_box">
            <div className="image_box_car">
              <img
                className="img-fluid"
                src="career-img/Block2.webp"
                alt="GsunTec Career"
              />
            </div>
            <div className="content_box_car">
              <h2>Collaborative Environment</h2>
              <p>
We believe the best ideas are born from collaboration. At NLF, you'll work alongside a multidisciplinary team that values open dialogue, diverse perspectives, and shared ownership of every success. Our design studios and project teams are structured to promote constant communication—from early brainstorming sessions to on-site execution—ensuring that creativity flows seamlessly into real-world results. If you thrive in environments where your voice matters and teamwork leads to tangible impact, you'll feel right at home with us.

              </p>
            </div>
          </div>
        </div>
        {/* <div
          className="col-md-4 text-center"
          data-aos="fade-right"
          data-aos-delay={100}
        >
          <div className="div_box">
            <div className="image_box_car">
              <img
                className="img-fluid"
                src="career-img/group-3.png"
                alt="GsunTec Career"
              />
            </div>
            <div className="content_box_car">
              <h2>Thrive As A Tribe</h2>
              <p>
              Join us to be part of an exciting journey where your ideas and contributions truly matter!
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  </div>
</section>

  </div>

  );
}

export default Code;